import React from "react";

export const isLogin = () => {
  return true;
};

const isValidEmail = (value) => {
  const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const isValid = pattern.test(value);
  return isValid;
};

export default isValidEmail;
